import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AttachmentsCreateDialogComponent } from './attachments-create-dialog.component';

@Component({
  selector: 'exa-attachments-create',
  templateUrl: './attachments-create.component.html',
  styleUrls: ['./attachments-create.component.scss']
})
export class AttachmentsCreateComponent implements OnInit {
  @Input() icon = 'add_comment';
  @Input() entity: string;
  @Input() entityId: string;

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

  onClickCreateAttachment() {
    this.dialog.open(AttachmentsCreateDialogComponent, {
      disableClose: true,
      data: {
        entity: this.entity,
        entityId: this.entityId,
      },
    })
  }
}
